import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/Form.module.css";
import {
  AddSanctionInitialState,
  AddSanctionValidationSchema,
} from "../../utils/sanction";
import Button from "../Button/Button";
import Input from "../Input/Input";
import InputSelect from "../Input/InputSelect";

import { socket } from "../../config/socket";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);

function FormSanction({ idMatch, teams }) {
  const sanctions = [
    { value: "5", label: "Tiro de esquina" },
    { value: "6", label: "Penal" },
  ];

  const handleSubmit = async (values) => {
    console.log(values);
    const { team, time, sanction, description } = values;

    const objIndex = sanctions.findIndex((obj) => obj.value === sanction);
    const title = sanctions[objIndex].label;

    socket.emit(
      "addStory",
      { idMatch, team, time, title, description, type: sanction },
      (story) => {
        MySwal.fire("story agregado");
        console.log(story);
      }
    );
  };

  return (
    <Formik
      initialValues={AddSanctionInitialState}
      validationSchema={AddSanctionValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.threeColumn)}>
            <InputSelect
              name="team"
              title="Equipo"
              error={touched.team && errors.team}
              options={teams}
              onChange={(selectedOption) => {
                handleChange("team")(selectedOption.value);
              }}
            />
            <InputSelect
              name="sanction"
              title="Sanción"
              error={touched.sanction && errors.sanction}
              options={sanctions}
              onChange={(selectedOption) => {
                handleChange("sanction")(selectedOption.value);
              }}
            />
            <Input name="time" title="Minuto de juego" type="number" />
            <div className={style.inputLong}>
              <Input name="description" title="Descripción" />
            </div>
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormSanction;
